import { API_BASE_URL } from './constants';
import { ApiError } from './api-client';
/**
 * fetch for public (unauthenticated) endpoints — onboarding, password reset.
 * Deliberately bypasses the shared apiClient (which auto-refreshes tokens on
 * 401) so we never send stale credentials from a logged-out visitor.
 */
export async function publicFetch(endpoint, init) {
    const res = await fetch(`${API_BASE_URL}${endpoint}`, {
        ...init,
        headers: {
            'Content-Type': 'application/json',
            ...init?.headers,
        },
    });
    const isJson = (res.headers.get('content-type') ?? '').includes('application/json');
    const body = isJson ? (await res.json()) : undefined;
    if (!res.ok) {
        throw new ApiError(body?.error?.code ?? 'INTERNAL_ERROR', body?.error?.message ?? 'Error desconocido', res.status);
    }
    return body?.data ?? undefined;
}
//# sourceMappingURL=public-fetch.js.map